import { Expose } from "@nts/std/serialization";
import { BaseIdentity } from './base-identity';
import { IdentityTypeNameDecorator } from './decorators/identity-type-name.decorator';
import type { SnapShotFrameIdentityInterface } from '@nts/std/interfaces';

@IdentityTypeNameDecorator('SnapShotFrameIdentity')
export class SnapShotFrameIdentity extends BaseIdentity implements SnapShotFrameIdentityInterface {

    private _identity: number;

    @Expose()
    get identity(): number {
        return this.getValue<number>(() => this._identity, 'identity');
    }
    set identity(value: number) {
        this.setValue<number>(() => { this._identity = value; }, value, 'identity');
    }

}
